/**
 * UI language for viewer chrome (controls hint, toolbar toasts).
 *
 * Resolution order:
 *   0. `<html lang="…" data-lang-fixed>`: a page that sets its own language
 *      whatever the browser says (demo.html, the stand demo: English unless
 *      another is picked in Setup, 21/10/2026).
 *   1. `?lang=` on the viewer URL — the CONTRACT with the marketing site,
 *      whose demo modal appends the language of the page the visitor is on
 *      (olloport.com auto-negotiates en/es/ca at the edge; the viewer must
 *      agree with the page that embeds it, not with the browser).
 *   2. a `lang` cookie, if one is visible on this origin.
 *   3. navigator.language.
 */

export type UiLang = 'en' | 'es' | 'ca';

export const toLang = (raw: string | null | undefined): UiLang | null => {
    const v = (raw ?? '').trim().toLowerCase();
    if (v.startsWith('ca')) return 'ca';
    if (v.startsWith('es')) return 'es';
    if (v.startsWith('en')) return 'en';
    return null;
};

export function resolveLang(): UiLang {
    try {
        const root = document.documentElement;
        if (root.dataset.langFixed !== undefined) return toLang(root.lang) ?? 'en';
        const q = toLang(new URLSearchParams(window.location.search).get('lang'));
        if (q) return q;
        const m = /(?:^|;\s*)lang=([A-Za-z-]+)/.exec(document.cookie);
        if (m) {
            const c = toLang(m[1]);
            if (c) return c;
        }
    } catch { /* fall through to navigator */ }
    return toLang(navigator.language) ?? 'en';
}
